/**
 * @generated SignedSource<<9c41700048d21a5fe719bc7db0587572>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeUserDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  userIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddIncludeUserDispatchConditionMutation$variables = {
  input: AddIncludeUserDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeUserDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeUserDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeUserDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeUserDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeUserDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeUserDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeUserDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeUserDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeUserDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e623abf259e5dc4e7e0640a8c9e043c",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeUserDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeUserDispatchConditionMutation(\n  $input: AddIncludeUserDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeUserDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1337817a175a88929dd351db6e209e3";

export default node;
